import { z } from 'zod';

/** Mirrors AdminProfileService: 2–50 characters once trimmed (Users.Name is nvarchar(50)). The backend re-checks it. */
export const profileSchema = z.object({
  name: z
    .string()
    .refine((value) => value.trim().length >= 2, 'Use at least 2 characters.')
    .refine((value) => value.trim().length <= 50, 'Keep it to 50 characters.'),
});

export type ProfileFormValues = z.infer<typeof profileSchema>;
